import { render, staticRenderFns } from "./fiveChart.vue?vue&type=template&id=47660b2f&"
import script from "./fiveChart.vue?vue&type=script&lang=js&"
export * from "./fiveChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports